var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',[_c('a-drawer',{attrs:{"visible":true,"placement":"right","width":"88%","destroy-on-close":true,"title":_vm.$t('views.orderPayment.drawer.title')},on:{"close":_vm.handleDrawerClose}},[_c('order-payment-panel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }